import React, { useEffect, useState } from "react";
import axios from "../api/axios";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [parentId, setParentId] = useState(""); // 🔹 NEW: track parent_id
  const [discount, setDiscount] = useState(""); // 🔹 NEW: track discount
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [discount_image, setDiscountImage] = useState(null);
  const [discountImagePreview, setDiscountImagePreview] = useState(null);

  const fetchCategories = async () => {
    try {
      const res = await axios.get("/admin/categories");
      setCategories(res.data.data || res.data);
    } catch (err) {
      console.error("Failed to fetch categories", err);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    } else {
      setImage(null);
      setImagePreview(null);
    }
  };
  const handleDiscountImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setDiscountImage(file);
    setDiscountImagePreview(URL.createObjectURL(file));
  } else {
    setDiscountImage(null);
    setDiscountImagePreview(null);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError("Category name is required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", name);
      if (parentId) formData.append("parent_id", parentId); // 🔹 send parent_id
      if (image) formData.append("image", image);
      if (discount) formData.append("discount", discount); // 🔹 send discount
      if (discount_image) formData.append("discount_image", discount_image);

      if (editId) {
        await axios.post(`/admin/categories/${editId}?_method=PUT`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await axios.post("/admin/categories", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      // Reset
      setName("");
      setParentId("");
      setImage(null);
      setDiscount("");
      setDiscountImage(null);
      setDiscountImagePreview(null);
      setImagePreview(null);
      setEditId(null);
      setError("");
      fetchCategories();
    } catch (err) {
      console.error("Failed to save category", err);
    }
  };

  const handleEdit = (category) => {
    setName(category.name);
    setParentId(category.parent_id || ""); // 🔹 prefill parent_id if exists
    setDiscount(category.discount || ""); // 🔹 prefill discount if exists
    setEditId(category.id);
    setError("");
    setImagePreview(category.image_url || null);
    setDiscountImagePreview(category.discount_image_url || null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    try {
      await axios.delete(`/admin/categories/${id}`);
      fetchCategories();
    } catch (err) {
      console.error("Failed to delete category", err);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">📂 Manage Categories</h5>
        </div>
        <div className="card-body">
          {/* Form */}
          <form onSubmit={handleSubmit} className="row g-3 align-items-end mb-4">
            <div className="col-md-4">
              <label className="form-label">Category Name</label>
              <input
                type="text"
                className={`form-control ${error ? "is-invalid" : ""}`}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter category name"
              />
              {error && <div className="invalid-feedback">{error}</div>}
            </div>

            <div className="col-md-3">
              <label className="form-label">Parent Category</label>
              <select
                className="form-select"
                value={parentId}
                onChange={(e) => setParentId(e.target.value)}
              >
                <option value="">-- Main Category --</option>
                {categories
                  .filter((cat) => !cat.parent_id) // show only main categories
                  .map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="col-md-3">
              <label className="form-label">Category Image</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageChange}
              />
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="img-thumbnail mt-2"
                  style={{ width: "80px", height: "80px", objectFit: "cover" }}
                />
              )}
            </div>
            <div className="col-md-2">
              <label className="form-label">Discount (%)</label>
              <input
                type="number"
                className={`form-control ${error ? "is-invalid" : ""}`}
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
                placeholder="Enter discount"
              />
              {error && <div className="invalid-feedback">{error}</div>}
            </div>
            <div className="col-md-3">
              <label className="form-label">Discount Image</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleDiscountImageChange}
              />
              {discountImagePreview && (
                <img
                  src={discountImagePreview}
                  alt="Preview"
                  className="img-thumbnail mt-2"
                  style={{ width: "80px", height: "80px", objectFit: "cover" }}
                />
              )}
            </div>
            <div className="col-md-2">
              <button type="submit" className="btn btn-success w-100">
                {editId ? "Update" : "Add"}
              </button>
            </div>
          </form>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Name</th>
                  <th>Parent</th>
                  <th>Image</th>
                  <th>Discount (%)</th>
                  <th>Discount Image</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {categories.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No categories found.
                    </td>
                  </tr>
                ) : (
                  categories.map((cat) => (
                    <tr key={cat.id}>
                      <td>{cat.name}</td>
                      <td>
                        {cat.parent_id
                          ? categories.find((p) => p.id === cat.parent_id)?.name
                          : "— Main —"}
                      </td>
                  
                      <td>
                        {cat.image_url ? (
                          <img
                            src={cat.image_url}
                            alt={cat.name}
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <span className="`text`-muted">No image</span>
                        )}
                      </td>
                          <td>{cat.discount || 0}</td>
                          <td>
                            {cat.discount_image_url ? (
                              <img
                                src={cat.discount_image_url}
                                alt={cat.name}
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <span className="text-muted">No image</span>
                            )}
                          </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={() => handleEdit(cat)}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(cat.id)}
                        >
                          🗑️ Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
